var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sc-form',{ref:"TestForm",attrs:{"autocomplete":"off"},scopedSlots:_vm._u([{key:"fields",fn:function(ref){
var fields = ref.fields;
return [_c('h1',[_vm._v("Etapa de teste")])]}},{key:"actions",fn:function(ref){
var isValid = ref.isValid;
return [_c('sc-button',{attrs:{"text":"Voltar","theme":"default","type":"button"},on:{"click":function($event){_vm.setActiveStep(3)}}}),_vm._v(" "),_c('sc-button',{attrs:{"text":"Próximo","theme":"primary","type":"button"},on:{"click":_vm.navigateNext}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02dc02b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-test/ScTest.vue
// module id = null
// module chunks = 